import { inject, Injectable } from '@angular/core';
import { PromoType } from '@data/domain/promo.entity';
import { UseCaseWithAdditionalArgs } from '@shared/helper';
import { ErrorMessageService } from '@shared/services/error-message/error-message.service';
import { catchError, map, Observable, throwError } from 'rxjs';
import { PackageRepository } from '../../../repositories/package.repository';
import {
  DataPackageList,
  GetPackageDto,
  GetPackageResp
} from './get-package.interface';

@Injectable({
  providedIn: 'root'
})
export class GetPackageUsecase
  implements
    UseCaseWithAdditionalArgs<GetPackageDto, PromoType, GetPackageResp>
{
  private readonly packageRepository = inject(PackageRepository);
  private readonly errorMessageService = inject(ErrorMessageService);

  execute(
    params: GetPackageDto,
    promoType: PromoType
  ): Observable<GetPackageResp> {
    return this.packageRepository.GetPackageList(params, promoType).pipe(
      map((res) => {
        return {
          ...res,
          package_list: res.package_list.map((p: DataPackageList) => {
            const FREE_PACKAGE = 0;
            return {
              ...p,
              btnLabel:
                p.price === FREE_PACKAGE
                  ? 'packageDetail.claim'
                  : 'packageDetail.buy'
            };
          })
        };
      }),
      catchError((error) => {
        const { status_code, msisdn } = error.error;
        return throwError(() =>
          this.errorMessageService.getErrorMessage(status_code, msisdn)
        );
      })
    );
  }
}
